import { useCallback, useEffect, useMemo, useState } from 'react';
import useBalanceSdk, { useGenerateBuyerToken } from './useBalanceSdk';

const useCreatePaymentMethod = (idModal, options) => {
  const { balanceWidget } = useBalanceSdk();
  const { data: token } = useGenerateBuyerToken();

  useEffect(() => {
    if (balanceWidget?.balanceSDK) {
      const { balanceSDK } = balanceWidget;
      balanceSDK?.paymentMethod?.init(options);
    }
  }, [balanceWidget, token]);

  const onOpenModal = useCallback(() => {
    options.onOpen();

    const { balanceSDK } = balanceWidget;
    balanceSDK?.paymentMethod?.render(token, idModal);
  }, [balanceWidget, token]);

  return {
    onOpenModal,
  };
};

export default useCreatePaymentMethod;
